// Query params Keycloak adds when it redirects back from the login page
export const OIDC_CALLBACK_PARAMS = ["state", "session_state", "code", "iss"] as const;

// The given URL with the Keycloak callback params removed, keeping any others.
// Used as the redirect_uri we register with Keycloak, and as the URL to restore once sign-in finishes.
export function currentCleanUri(href: string = window.location.href): string {
  const url = new URL(href);
  OIDC_CALLBACK_PARAMS.forEach((param) => url.searchParams.delete(param));

  const query = url.searchParams.toString();
  return url.origin + url.pathname + (query ? `?${query}` : "");
}

// True when the current URL is Keycloak handing us back a completed login
export function hasOidcCallbackParams(search: string = window.location.search): boolean {
  const params = new URLSearchParams(search);
  return params.has("code") && params.has("state");
}
